import styles from "./FiltersHeading.module.scss";

export function FiltersHeading() {
  return (
    // Used to ensure accessible landmark for screen readers
    <h2 className={styles.visuallyHidden}>Filters</h2>
  );
}
